import PersonalityType from "components/NewDesign/PersonalityType";
import ProfessionalOrientation from "components/NewDesign/ProfessionalOrientation";
import { useEffect, useState } from "react";
import { useStore } from "../../../store/useStore";
import Loading from "../../../components/OldDesign/Loading";
import { useNavigate } from "react-router-dom";
import i18n from "i18n";
import { getUserWebLanguage } from "api/endpoints";

const InGameMetaCv = () => {
  const navigate = useNavigate();
  const getOverviewContent = useStore((state) => state.getOverview);
  const overview = useStore((state) => state.overview);
  const code = new URLSearchParams(window.location.search).get("code");
  const [langSynced, setLangSynced] = useState(false);
  const handleGetUserWebLanguage = async (params) => {
    const { code } = params;
    let lang = "tr";
    try {
      await getUserWebLanguage({ code }, (res) => {
        if (res?.data?.lang) {
          lang = res.data.lang;
        }
      });
      i18n.changeLanguage(lang).then(() => {
        setLangSynced(true);
      });
    } catch (error) {
      console.error("Error setting user web language:", error);
    }
  };
  useEffect(() => {
    if (code) {
      const decodedCode = atob(code);
      localStorage.setItem("token", decodedCode);
      if (!langSynced) {
        handleGetUserWebLanguage({ code });
      } else {
        getOverviewContent();
      }
    } else {
      navigate("/login");
    }
  }, [getOverviewContent, navigate, code, langSynced]);
  if (overview.isLoading) {
    return <Loading />;
  }
  if (!overview.isLoaded) {
    return null;
  }

  return (
    <div>
      <PersonalityType />
      <ProfessionalOrientation />
    </div>
  );
};

export default InGameMetaCv;
